import type { ToolId } from "../../features/toolExperience/types";
export const homeSourcePolicies: Record<
  ToolId,
  "records" | "connection" | "unavailable"
> = {
  briefings: "records",
  monitoring: "records",
  similarity: "records",
  clustering: "records",
  wordcloud: "records",
  analytics: "connection",
  "competitor-analysis": "unavailable",
};
